/**
 * Resolve o `:marca` de uma rota de ajuda para um caminho navegável.
 *
 * 🔴 **O caso sem marca no contexto é o que importa.** A página de ajuda vive em
 * `/ajuda`, fora de qualquer marca — então um verbete que aponta para
 * `/marcas/:marca/simulacao` não tem por onde resolver o parâmetro. Deixar o
 * `:marca` no `href` produz um link que abre em nada, que é exatamente o defeito
 * que o critério 7 da demanda 040 existe para impedir: documentação que quebra a
 * confiança em silêncio.
 *
 * Sem marca, o link leva à lista de marcas — onde a pessoa escolhe uma e chega
 * ao mesmo lugar em dois cliques em vez de nenhum.
 */
export function resolverRota(caminho: string, marca?: string): string {
  if (!caminho.includes(':marca')) return caminho

  if (marca) return caminho.replace(':marca', encodeURIComponent(marca))

  return '/marcas'
}

/** Se o destino final depende de escolher uma marca antes. */
export function precisaEscolherMarca(caminho: string, marca?: string): boolean {
  return caminho.includes(':marca') && !marca
}
